export enum NotificationCloseHandlerType {
    Reload = 'Reload',
    Init = 'Init',
    UserAccountDeletedExit = 'UserAccountDeletedExit',
}
